jQuery(document).ready(function () {
    $(document).on('click','.dnModal-trigger',function(e){
        e.preventDefault();
        var button = $(this);
        var modalId = button.attr('data-id');
        var modalLinkData = button.attr('data-load');
        var modalLinkHref = button.attr('href');

        var modalLink = modalLinkData !== undefined ? modalLinkData : modalLinkHref;

        var modalContainer = button.attr('data-container');

        var modalBody = $(modalId).modal('show').find('.dnModal-body-loadableContent');

        if (!modalBody.attr('loaded') && modalLink) {
            modalBody.load(
                modalLink + " " + modalContainer,
                function() {
                    modalBody.attr('loaded', 'loaded');

                    $(modalId).trigger('loaded.bs.modal');
                }
            );
        }
    });

    $(document).on('hidden.bs.modal', '.dnModal-unloadOnClose', function (e) {
        var modal = $(e.currentTarget);
        var loadableClass = 'dnModal-body-loadableContent';

        modal.find('.'+loadableClass).replaceWith('<div class="' + loadableClass + '"></div>');
    });
});
